import { $isInIos, $preventDefaultIos, $isXunMengTu } from '@/util/util'
import { global } from '@/config/global'
const SET_ACTIVITY_ID = 'SET_ACTIVITY_ID'
const SET_DATA_FROM_APP = 'SET_DATA_FROM_APP'
const SET_RATIO_INFO = 'SET_RATIO_INFO'
const SET_PRODUCT_LIST = 'SET_PRODUCT_LIST'
const SET_COUPON_LIST = 'SET_COUPON_LIST'
const SET_COUPONS_HISTORY = 'SET_COUPONS_HISTORY'
const SET_ACTIVITY_CONFIG = 'SET_ACTIVITY_CONFIG'
const SET_TASK_LIST = 'SET_TASK_LIST'
const SET_SHARE_TASK_ID = 'SET_SHARE_TASK_ID'
const SET_SHARE_COUPON_ID = 'SET_SHARE_COUPON_ID'
const SET_BIND_ROLE_INFO = 'SET_BIND_ROLE_INFO'
const SET_CLICK_LOTTERY_BTN = 'SET_CLICK_LOTTERY_BTN'
const SET_CLICK_BOTTOM_BUY_BTN = 'SET_CLICK_BOTTOM_BUY_BTN'
const SET_FINISH_PAY_ACTION = 'SET_FINISH_PAY_ACTION'

export default {
  [SET_ACTIVITY_ID] (state, data) {
    state.activityID = data
  },
  [SET_DATA_FROM_APP] (state) {
    try {
      if ($isInIos()) {
        $preventDefaultIos()
        state.isInIos = true
        state.userInfo = window.iOSApp.getAppUserInfo()
        state.appVersion = state.userInfo.cur_version || 0
        state.userInfo.statusBarHeight && (state.statusBarHeight = state.userInfo.statusBarHeight)
        state.isLogin = !!state.userInfo.phoneNumber || !!state.userInfo.userName
      } else {
        // 版本号赋值，因为安卓官网版本号>10000。所以有如下计算
        let version = window.webapp.getAppVersionCode()
        const diff = 10000
        state.appVersion = version - diff > 0 ? version - diff : version
        state.userInfo = JSON.parse(window.webapp.getAppUserInfo())
        state.statusBarHeight = window.webapp.getStatusBarHeightRatio() * 100
        state.channel = window.webapp.getChannel()
        state.isLogin = !!state.userInfo.phoneNumber || !!state.userInfo.userName
      }
    } catch (error) {
      console.log(error)
      state.isOutSide = true
    }
  },
  [SET_RATIO_INFO] (state, data) {
    state.h5ConfigDetails = data.h5ConfigDetails
    state.h5ConfigImgPath = data.h5ConfigImgPath
    state.llkSwitchOn = state.h5ConfigDetails[0].llkText && Number(state.h5ConfigDetails[0].llkText.llkSwitch[0]) && !$isXunMengTu()
  },
  [SET_PRODUCT_LIST] (state, data) {
    state.productList = data
  },
  [SET_COUPON_LIST] (state, couponList) {
    state.couponList = couponList
  },
  [SET_COUPONS_HISTORY] (state, couponsHistory) {
    state.couponsHistory = couponsHistory
  },
  [SET_TASK_LIST] (state, taskList) {
    state.taskList = taskList
  },
  [SET_ACTIVITY_CONFIG] (state, activityConfig) {
    state.activityConfig = activityConfig
  },
  [SET_SHARE_TASK_ID] (state, shareTaskId) {
    state.shareInTaskId = shareTaskId
  },
  [SET_SHARE_COUPON_ID] (state, shareCouponId) {
    state.shareInCouponId = shareCouponId
  },
  [SET_BIND_ROLE_INFO] (state, payload) {
    const gameCode = payload.miniProgram.gameId || 'cjm'
    const actId = payload.miniProgram.actId || ''
    const info = payload.roleInfo
    if (!info.bindRoles.length) {
      return
    }
    
    const bindRole = info.bindRoles.find(ele => ele.gameCode === gameCode)
    console.log(bindRole)

    if (!bindRole || !bindRole.roleName) {
      return
    }

    // 目前只有和平，所以默认取第一个元素，后续livelink增加合作方再扩展
    state.bindRoleInfo = bindRole

    if (payload.isRefresh) {
      // 每次成功更新都记录操作时间，保证5min内无法再次绑定
      localStorage.setItem(`${global.LOCAL_STORAGE_FLAG_BASE}-${actId}`, new Date().getTime());
    }
  },

  [SET_CLICK_LOTTERY_BTN] (state) {
    state.hasClickLotteryBtn = true
  },
  [SET_CLICK_BOTTOM_BUY_BTN] (state) {
    state.hasClickBottomBuyBtn = true
  },
  [SET_FINISH_PAY_ACTION] (state) {
    state.hasFinishPayAction = true
  }
}
